/* FNDRY — what to expect timeline */
(function () {
  'use strict';

  var SELECTOR = '[data-fndry-timeline]';
  /* Where the "reading line" sits, as a share of viewport height. The spine
     fills to this line and chips light as it passes them. */
  var LINE = 0.62;
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function Timeline(root) {
    if (root.dataset.fndryTimelineReady === 'true') return;
    root.dataset.fndryTimelineReady = 'true';

    var flow = root.querySelector('[data-ftl-flow]');
    var chips = slice(root.querySelectorAll('[data-ftl-chip]'));
    var stages = slice(root.querySelectorAll('[data-ftl-stage]'));
    var revealEls = slice(root.querySelectorAll('[data-ftl-reveal]'));

    /* ---------- scroll reveal ---------- */

    var animate = root.dataset.ftlAnimate === 'true';

    if (animate && !reduceMQ.matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add('is-in');
            /* Re-arm only once the element has left downwards, so it plays
               again on the next approach instead of firing once on load. */
            else if (entry.boundingClientRect.top > 0) entry.target.classList.remove('is-in');
          });
        },
        { threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }

    /* ---------- spine fill ---------- */

    /* CSS ships the spine filled and the chips lit, so no-JS and reduced
       motion both read as a completed timeline. Only take that apart when
       this driver is actually going to run. */
    if (flow && chips.length && !reduceMQ.matches && window.requestAnimationFrame) {
      /* P15 sitewide 2026-10-23: this ran on every scroll frame of the page,
         top to footer, and wrote the fill before reading each chip's rect -
         a forced restyle and layout per frame, the heaviest scroll work on
         the What to expect page. Now it reads everything before it writes,
         writes only what changed, and runs only while the timeline is within
         a screen of the viewport (one update on the way in and out, so it
         rests empty below and full above, as before). Same fill, same chips. */
      var ticking = false;
      var painted = null;
      var passed = chips.map(function () { return false; });
      var near = !('IntersectionObserver' in window);

      var frame = function () {
        ticking = false;
        var rect = flow.getBoundingClientRect();
        if (!rect.height) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var line = vh * LINE;
        var p = (line - rect.top) / rect.height;
        p = Math.max(0, Math.min(1, p));
        var now = chips.map(function (chip) {
          var box = chip.getBoundingClientRect();
          return box.top + box.height / 2 <= line;
        });
        var value = p.toFixed(4);
        if (value !== painted) {
          painted = value;
          flow.style.setProperty('--ftl-p', value);
        }
        for (var i = 0; i < chips.length; i++) {
          if (now[i] !== passed[i]) {
            passed[i] = now[i];
            chips[i].classList.toggle('is-passed', now[i]);
          }
        }
      };

      var schedule = function () {
        if (!near || ticking) return;
        ticking = true;
        window.requestAnimationFrame(frame);
      };

      flow.style.setProperty('--ftl-p', '0');
      painted = '0.0000';
      chips.forEach(function (chip) {
        chip.classList.remove('is-passed');
      });

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      if (!near) {
        new IntersectionObserver(function (entries) {
          near = entries[entries.length - 1].isIntersecting;
          frame();
        }, { rootMargin: '100% 0px 100% 0px' }).observe(root);
      }
      frame();
    }

    /* ---------- theme editor ---------- */

    function onBlockSelect(event) {
      if (!document.body.contains(root)) return;
      var id = event.detail && event.detail.blockId;
      if (!id) return;
      for (var i = 0; i < stages.length; i++) {
        if (stages[i].dataset.blockId === id) {
          stages[i].scrollIntoView({
            block: 'center',
            behavior: reduceMQ.matches ? 'auto' : 'smooth'
          });
          return;
        }
      }
    }
    document.addEventListener('shopify:block:select', onBlockSelect);
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var found = slice(context.querySelectorAll(SELECTOR));
    if (context.matches && context.matches(SELECTOR)) found.unshift(context);
    found.forEach(function (el) {
      try {
        new Timeline(el);
      } catch (error) {
        /* Never leave copy stranded hidden or the spine drained. */
        el.setAttribute('data-ftl-animate', 'false');
        var flow = el.querySelector('[data-ftl-flow]');
        if (flow) flow.style.removeProperty('--ftl-p');
        slice(el.querySelectorAll('[data-ftl-chip]')).forEach(function (chip) {
          chip.classList.add('is-passed');
        });
        if (window.console) console.error('[fndry-timeline]', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
